import React from 'react';
import PropTypes from 'prop-types';
import View from './View/View';
import Search from './Search/Search';
import Filters from './Filters/Filters';
import Total from './Total/Total';
import closeIcon from './images/close-icon.svg';

const HeaderDesktop = ({
    currentPath,
    keyword,
    filters,
    filtersOff,
    options,
    maxSqFts,
    handleKeywordChange,
    handleFilterChange,
    handleClear,
    totalText,
}) => (
    <div id="_searching" className="section grid-search-container">
        <div className="container">
            <div className="columns">
                <div className="column is-offset-1-desktop is-10-desktop">
                    {!filtersOff &&
                        <button onClick={handleClear} className="clear-button-wrapper">
                            <img className="button-icon" src={closeIcon} alt={closeIcon} />
                            <div className="button-text">CLEAR FILTERS</div>
                        </button>
                    }
                    <div className="filters-title">FILTERS</div>
                    <div className="columns vertical-align">
                        <div className="column">
                            <View currentPath={currentPath} />
                        </div>
                        <div className="column is-10">
                            <Search keyword={keyword} handleChange={handleKeywordChange} />
                        </div>
                    </div>
                    <Filters
                        filters={filters}
                        options={options}
                        maxAvailSqFt={maxSqFts}
                        handleChange={handleFilterChange}
                        handleClear={handleClear} />
                    <Total totalText={totalText} />
                </div>
            </div>
        </div>
    </div>
);

HeaderDesktop.propTypes = {
    currentPath: PropTypes.string.isRequired,
    keyword: PropTypes.string,
    filters: PropTypes.object.isRequired,
    filtersOff: PropTypes.bool.isRequired,
    options: PropTypes.object.isRequired,
    maxSqFts: PropTypes.number.isRequired,
    totalText: PropTypes.string,
    handleKeywordChange: PropTypes.func.isRequired,
    handleFilterChange: PropTypes.func.isRequired,
    handleClear: PropTypes.func.isRequired,
};

export default HeaderDesktop;
